const WareHousing = () => {
  return (
    <div>
      <div className="flex flex-col justify-center items-center">
      <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">
         
          <div className="flex flex-col justify-center">
            <h1 className="font-bold text-3xl text-[#373737]">
              Warehousing 
            </h1>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[30rem] mt-[1rem]">
              Companies today are under an enormous pressure to capitalise on evolving business trends 
              and make use of integrated logistics and dynamic sourcing, while simultaneously increasing 
              efficiency and reducing costs. To meet these challenges, TCS provides a broad suite of innovative
              applications that enables organisations to modernise their supply chain processes by adding
              cloud-based warehouse management capabilities, which includes: 
            </p>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[30rem] mt-[1rem]">
              <ul className="list-disc list-inside">
                <li>Managing warehouses nationwide</li>
                <li>Temperature controlled and ambient warehousing</li>
                <li>In-house WMS is compatible with other ERPs through EDI</li>
                <li>Reverse logistics</li>
                <li>Primary & secondary distribution</li>
                <li>Value added services</li>
                <li>Focused Verticals</li>
                <li>Healthcare & Pharma</li>
                <li>FMCG</li>
                <li>Automobiles</li>
                <li>Telecom</li>
                <li> Fashion & Retail</li>
              </ul>
       
            </p>
          </div>
          <div className="flex-1 flex flex-col justify-center items-center">
            <img src="/DomesticScrollingBanner/scrolling-image20.jpg" alt="" className="max-w-[45rem] h-[30vh]"/>
          </div>
        </div>
      
      </div>
    </div>
  );
};
  
export default WareHousing;
  